module.exports = __webpack_public_path__ + "static/media/summary.4627d058.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/summary.svg
// module id = 3137
// module chunks = 0